import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
// file unit test nya mana
// udah ada di shared
export class BasicTokenState<T> {
  private state$: BehaviorSubject<T | null>;
  protected get state(): T | null {
    return this.state$.getValue();
  }

  constructor(initialState: T) {
    this.state$ = new BehaviorSubject<T | null>(initialState);
  }

  protected select<K>(mapFn: (state: T) => K): Observable<K | null> {
    return this.state$.asObservable().pipe(
      map((state: T | null) => state !== null ? mapFn(state) : null),
      distinctUntilChanged()
    );
  }

  protected setState(newState: Partial<T>) {
    this.state$.next({
      ...this.state,
      ...newState
    } as T);
  }

  protected removeState(): void {
    this.state$.next(null);
  }
}
